<template>
    <!-- Comapny Address Tab Content View From Company Profile -->
    <div class="tabs-content-firstblock">
        <div class="row">
            <div class="col-lg-12">
                <div class="infoHeader ml-2 mr-1">
                    <div class="descriptionheader">
                        <div class="description-text-header-left col-md-10">
                            <h5>
                                <i class="crmnew-marker iconsize-16 pr-2 defaultBlue"></i>
                                <!-- <img class="activityContact pr-2" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/crm/icons/marker.svg"> -->
                                Branch Information
                            </h5>
                        </div>
                        <a
                            href="javascript:;"
                            class="btn btn-secondary btn-smm  pull-right col-md-2"
                            v-on:click="editCompanyProfile()"
                        >
                            <i class="icon-pencil pr-1" style="font-size: 16px;"></i>
                            Edit
                        </a>
                        <!-- <div class="description-text-header-right">
                            <i class="icon icon-pencil"></i>
                        </div> -->
                    </div>
                </div>
                <!-- <div class="header-inline">
                    <div class="headerTitleView ml-8">
                        <span class="fs-14 defaultBlue aboutHeading">Branch Information</span>
                    </div>
                    <span class="header-inline-edit">
                        <i class="icon icon-pencil"></i>
                        <i class="icon icon-check"></i>
                        <i class="icon icon-close"></i>
                    </span>
                </div> -->
                <div class="ml-2 mr-1 mt-5 mb-3" v-for="(branch, index) in companyData.branches" :key="index">
                    <el-collapse class="el-collapse-info" v-model="activeBranchInfo">
                        <el-collapse-item class="mb-4" :title="'Branch '+parseInt(index+1).toString()" :name="parseInt(index+1).toString()">
                            <div class="a-q-Jc-j-contactView">
                                <div class="a-q-Jc-Pj-Ya-contactView new-contactView pl-0">
                                    <div class="a-q-Jc-bj-contactView ml-0">Branch Code</div>
                                    <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                        <span class="a-q-Jc-wg-contactView font-color">
                                            {{ branch.code || '-' }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="a-q-Jc-j-contactView">
                                <div class="a-q-Jc-Pj-Ya-contactView new-contactView pl-0">
                                    <div class="a-q-Jc-bj-contactView ml-0">Branch Name</div>
                                    <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                        <span class="a-q-Jc-wg-contactView font-color">
                                            {{ branch.name || '-' }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="a-q-Jc-j-contactView">
                                <div class="a-q-Jc-Pj-Ya-contactView pl-0">
                                    <div class="a-q-Jc-bj-contactView ml-0">Department Name</div>
                                    <div class="a-q-Jc-Lb-contactView">
                                        <span class="a-q-Jc-wg-contactView font-color">
                                            {{ branch.department_name || '-' }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="a-q-Jc-j-contactView">
                                <div class="a-q-Jc-Pj-Ya-contactView pl-0" v-for="(department, branchIndex) in branch.deapartment" :key="branchIndex">
                                    <div class="a-q-Jc-bj-contactView ml-0">Department - {{index+1}}</div>
                                    <div class="a-q-Jc-Lb-contactView">
                                        <span class="a-q-Jc-wg-contactView font-color">
                                            {{department.department_name || '-' }}
                                        </span>
                                    </div>
                                </div>
                            </div> -->
                            <div class="a-q-Jc-j-contactView">
                                <div class="a-q-Jc-Pj-Ya-contactView new-contactView pl-0">
                                    <div class="a-q-Jc-bj-contactView ml-0">Branch Website Address</div>
                                    <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                        <span class="a-q-Jc-wg-contactView font-color">
                                            <a :href="branch.website" target="_blank">{{ branch.website || '-' }}</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="a-q-Jc-j-contactView">
                                <div class="a-q-Jc-Pj-Ya-contactView new-contactView pl-0">
                                    <div class="a-q-Jc-bj-contactView ml-0">Branch Email</div>
                                    <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                        <span class="a-q-Jc-wg-contactView font-color">
                                            {{ branch.primary_email || '-' }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="a-q-Jc-j-contactView">
                                <div class="a-q-Jc-Pj-Ya-contactView  new-contactView pl-0" v-for="(email, branchIndex) in branch.email" :key="branchIndex">
                                    <div class="a-q-Jc-bj-contactView ml-0">Alternate Email - {{index+1}}</div>
                                    <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                        <span class="a-q-Jc-wg-contactView font-color">
                                            {{email.email_id || '-' }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="a-q-Jc-j-contactView">
                                <div class="a-q-Jc-Pj-Ya-contactView new-contactView pl-0">
                                    <div class="a-q-Jc-bj-contactView ml-0">Branch Phone Number</div>
                                    <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                        <span class="a-q-Jc-wg-contactView font-color" v-if="branch.primary_phone">
                                            {{ branch.primary_phone.phone_number || '-'  }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="a-q-Jc-j-contactView">
                                <div class="a-q-Jc-Pj-Ya-contactView new-contactView pl-0" v-for="(phone, branchIndex) in branch.phone_details" :key="branchIndex">
                                    <div class="a-q-Jc-bj-contactView ml-0">Alternate Phone Number - {{index+1}}</div>
                                    <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                        <span class="a-q-Jc-wg-contactView font-color">
                                            {{ phone.phone_number || '-' }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="a-q-Jc-j-contactView">
                                <div class="a-q-Jc-Pj-Ya-contactView pl-0">
                                    <div class="a-q-Jc-bj-contactView ml-0">Email</div>
                                    <div class="a-q-Jc-Lb-contactView">
                                        <span class="a-q-Jc-wg-contactView font-color">
                                            digicollect@gmail.com
                                        </span>
                                    </div>
                                </div>
                            </!-->
                            <!-- <div class="a-q-Jc-j-contactView">
                                <div class="a-q-Jc-Pj-Ya-contactView pl-0">
                                    <div class="a-q-Jc-bj-contactView ml-0">Phone Number</div>
                                    <div class="a-q-Jc-Lb-contactView">
                                        <span class="a-q-Jc-wg-contactView font-color">
                                            +1.212.683.0400
                                        </span>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="a-q-Jc-j-contactView">
                                <div class="a-q-Jc-Pj-Ya-contactView pl-0">
                                    <div class="a-q-Jc-bj-contactView ml-0">Alternate Number</div>
                                    <div class="a-q-Jc-Lb-contactView">
                                        <span class="a-q-Jc-wg-contactView font-color">
                                            +91 98450 98450
                                        </span>
                                    </div>
                                </div>
                            </div> -->
                            <h6 class="mt-3" style="padding: 5px 0px;font-size: 14px;font-weight: 600;line-height: 1.2;letter-spacing: 0.1px;color: #4e5764;">
                                Address
                            </h6>
                            <div v-if="branch.address">
                                <div class="d-flex flex-row align-items-center mt-5">
                                    <span class="mr-4" style="color: #303031">Address Type :</span>
                                    <div class="preview-elements">
                                    <div class="form-check form-check-inline user-perm">
                                        <label
                                            class="form-check-label check-label-dc"
                                            style="width: 80px !important;"
                                        >
                                            <input
                                            class="form-check-input"
                                            type="radio"
                                            value="Office"
                                            v-model="branch.address.address_type"
                                            disabled
                                            />
                                            <span class="radio-icon"></span>
                                            <span class="form-check-description fw-600">Office</span>
                                        </label>
                                    </div>
                                    <div class="form-check form-check-inline user-perm">
                                        <label class="form-check-label check-label-dc">
                                            <input
                                            class="form-check-input"
                                            type="radio"
                                            value="Factory"
                                            v-model="branch.address.address_type"
                                            disabled
                                            />
                                        <span class="radio-icon"></span>
                                        <span class="form-check-description fw-600">Factory</span>
                                        </label>
                                    </div>
                                    <div class="form-check form-check-inline user-perm">
                                        <label class="form-check-label check-label-dc">
                                        <input
                                        class="form-check-input"
                                        type="radio"
                                        value="Others"
                                        v-model="branch.address.address_type"
                                        disabled
                                        />
                                        <span class="radio-icon"></span>
                                        <span class="form-check-description fw-600">Others</span>
                                        </label>
                                    </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-contactView mt-2">
                                    <div class="a-q-Jc-Pj-Ya-contactView new-contactView pl-0">
                                        <div class="a-q-Jc-bj-contactView ml-0">Building No</div>
                                        <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                            <span class="a-q-Jc-wg-contactView font-color">
                                                {{ branch.address.building_number }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-contactView mt-2">
                                    <div class="a-q-Jc-Pj-Ya-contactView new-contactView pl-0">
                                        <div class="a-q-Jc-bj-contactView ml-0">Street 1</div>
                                        <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                            <span class="a-q-Jc-wg-contactView font-color">
                                                {{ branch.address.street }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-contactView mt-2">
                                    <div class="a-q-Jc-Pj-Ya-contactView new-contactView pl-0">
                                        <div class="a-q-Jc-bj-contactView ml-0">Street 2</div>
                                        <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                            <span class="a-q-Jc-wg-contactView font-color">
                                                {{ branch.address.street2 }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-contactView">
                                    <div class="a-q-Jc-Pj-Ya-contactView new-contactView pl-0">
                                        <div class="a-q-Jc-bj-contactView ml-0">City</div>
                                        <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                            <span class="a-q-Jc-wg-contactView font-color">
                                                {{ branch.address.city }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-contactView">
                                    <div class="a-q-Jc-Pj-Ya-contactView new-contactView pl-0">
                                        <div class="a-q-Jc-bj-contactView ml-0">Township</div>
                                        <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                            <span class="a-q-Jc-wg-contactView font-color">
                                                {{ branch.address.township }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-contactView">
                                    <div class="a-q-Jc-Pj-Ya-contactView new-contactView pl-0">
                                        <div class="a-q-Jc-bj-contactView ml-0">State</div>
                                        <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                            <span class="a-q-Jc-wg-contactView font-color">
                                                {{ branch.address.state }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-contactView">
                                    <div class="a-q-Jc-Pj-Ya-contactView new-contactView pl-0">
                                        <div class="a-q-Jc-bj-contactView ml-0">Zip Code</div>
                                        <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                            <span class="a-q-Jc-wg-contactView font-color">
                                                {{ branch.address.zip_code }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-contactView">
                                    <div class="a-q-Jc-Pj-Ya-contactView new-contactView pl-0" style="border-bottom: 0px solid transparent !important;">
                                        <div class="a-q-Jc-bj-contactView ml-0">Country</div>
                                        <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                            <span class="a-q-Jc-wg-contactView font-color">
                                                {{ branch.address.country }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mt-4 mr-2" style="height: 200px">
                                    <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12" style="height: 100%; width: 100%;">
                                        <gmap-map
                                            :center="{lat: branch.address.latitude ? branch.address.latitude : 0, lng: branch.address.longitude ? branch.address.longitude : 0}"
                                            :zoom="2"
                                            style="width: 100%; height: 100%; border-radius: 6px;"
                                        >
                                        </gmap-map>
                                    </div>
                                    <div class="d-flex justify-content-center align-items-center col-lg-7 col-md-7 col-sm-12 col-xs-12" style="height: 100%; width: 100%; background: #f5f6f9; border-radius: 6px;">
                                        <i class="icon-map-marker" style="color: #00448b;font-size: 18px;width: 18px;height: 18px;line-height: 18px;"></i>
                                        <span>
                                            {{branch.address.street + ', ' || ''}}{{branch.address.city + ', ' || ''}}{{branch.address.state + ', ' || ''}}{{branch.address.zip_code + ', ' || ''}}{{branch.address.country || ''}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <p>Address Not Found</p>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["companyData"],
    data() {
        return {
            activeBranchInfo: ['1'],
            center: {
                lat: 28.033886,
                lng: 1.659626
            },
            infoContent: '',
            infoWindowPos: null,
            infoWinOpen: true,
            currentMidx: null,
            //optional: offset infowindow so it visually sits nicely on top of our marker
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35
                }
            },
            markers:
            [{
                position: {
                    lat: 40.745372,
                    lng: -73.982107
                },
                infoText: '1185 Avenue of the Americas, 3rd Floor New York, NY 10036 USA'
                },{
                position: {
                    lat: 12.967748,
                    lng: 77.593412
                },
                infoText: 'No. 40, Raja Rammohan Roy Road, Opposite Sree Kanteerava Stadium, Bangalore 560 027'
            }]
        }
    },
    methods: {
        // Vue Google Maps for Location View
        toggleInfoWindow: function(marker, idx) {
            this.infoWindowPos = marker.position;
            this.infoContent = marker.infoText;
            //check if its the same marker that was selected if yes toggle
            if (this.currentMidx == idx) {
              this.infoWinOpen = !this.infoWinOpen;
            }
            //if different marker set infowindow to open and reset current marker index
            else {
              this.infoWinOpen = true;
              this.currentMidx = idx;
            }
        },
        editCompanyProfile() {
        this.$router.push({
            name: "EditCompanyProfile",
            params: { id: this.$route.params.id },
        });
        }
    },
    mounted() {
    }

}
</script>
<style scoped>
.vue-map-container .vue-map {
    border-radius: 12px !important;
}
.mapaddress-block {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-shadow: 0 0 13px 0 rgba(82,63,105,.05);
    box-shadow: 0 0 13px 0 rgba(82,63,105,.05);
    background-color: #fff;
    margin-top: 10px;
    margin-bottom: 6px;
    border-radius: 12px;
    padding: 20px 15px 0px;
}
/* .mapouter{position:relative;text-align:right;height:400px;}.gmap_canvas {overflow:hidden;background:none!important;height:400px;width:440px;border-radius: 12px;} */
.kt-widget31 .kt-widget31__item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 1rem;
}
.kt-widget31 .kt-widget31__item .kt-widget31__content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.kt-widget31 .kt-widget31__item .kt-widget31__content_info {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.kt-widget31 .kt-widget31__item .kt-widget31__content:last-child {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: flex-end;
    -webkit-box-align: flex-start;
    -ms-flex-align: center;
    align-items: flex-start;
    width: 30%;
}
.kt-widget31 .kt-widget31__item .kt-widget31__content .kt-widget31__pic>img {
    width: 4rem;
    border-radius: 50%;
}
.kt-widget31 .kt-widget31__item .kt-widget31__content .kt-widget31__info {
    padding: 0 0rem;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
}
.kt-widget31 .kt-widget31__item .kt-widget31__content .kt-widget31__info .kt-widget31__username {
    font-weight: 900;
    font-size: 16px;
    color: #4e5764;
    -webkit-transition: color .3s ease;
    transition: color .3s ease;
    text-decoration: none;
    background-color: transparent;
    outline: 0!important;
    line-height: 1.22;
    letter-spacing: 0.12px;
}
.kt-widget31 .kt-widget31__item .kt-widget31__content .kt-widget31__info .kt-widget31__text {
    font-size: 13px;
    margin: 0;
    font-weight: normal;
    color: #4e5764;
    line-height: 1.22;
    letter-spacing: 0.12px;
}
.btnlabel {
    display: inline-block;
    font-weight: 400;
    color: #fff;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.22;
    letter-spacing: 0.12px;
    border-radius: 18px;
    text-decoration: none;
    -webkit-transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    min-width: 8.8rem;
}
.btnlabel-sm {
    font-size: 14px;
    line-height: 1.22;
    border-radius: 18px;
}
.btnlabel {
    background: 0 0;
    outline: 0!important;
    vertical-align: middle;
}
.btnlabel {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.btnlabel.btnlabel-bold {
    font-weight: 600;
}
.btnlabel.btnlabel-label-brand {
    background-color: #00448b;
    color: #fff;
    cursor: text!important;
}
.new-contactView-item{
    padding: 16px 10px 16px 3px !important;
}
.new-contactView {
    display: flex;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/CompanyAddressView.vue